import is from '@sindresorhus/is';
import type { FunctionComponent, ReactNode } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { DataCell } from '../../../../../design/components/data-grid/DataGridContainer';
import { useOneUserQuery } from '../../../../query-hooks/users';
import { SidebarCard } from './SidebarCard';

type ContactProps = {
    readonly detailActions?: ReactNode;
    readonly userId: string;
};

type VisibleContact = {
    readonly label: string;
    readonly value: string;
};

export const Contact: FunctionComponent<ContactProps> = ({ detailActions, userId }) => {
    const { userQuery } = useOneUserQuery(userId);
    const { applicationState, translate } = useContext(ApplicationContext);
    const { myUserProfile, userIsAnonymized } = applicationState;
    const isCurrentUsersProfile = myUserProfile.get('id').mapOr(false, (myUserProfileId) => {
        return myUserProfileId === userId;
    });
    const isAnonymizationActive = userIsAnonymized && !isCurrentUsersProfile;

    const { emailAddress, phoneNumber } = userQuery.data ?? {};

    const visibleContacts: readonly VisibleContact[] = [
        ...(is.nonEmptyString(emailAddress)
            ? [
                  {
                      label: translate('pages.recruiter-profile.contact.e-mail'),
                      value: isAnonymizationActive ? translate('common.email-hidden') : emailAddress,
                  },
              ]
            : []),
        ...(is.nonEmptyString(phoneNumber)
            ? [
                  {
                      label: translate('pages.edit-profile-details.phone'),
                      value: isAnonymizationActive ? translate('common.phone-hidden') : phoneNumber,
                  },
              ]
            : []),
    ];

    return (
        <SidebarCard detailActions={detailActions} title={translate('pages.recruiter-profile.contact.title')}>
            {visibleContacts.map(({ label, value }) => (
                <DataCell key={label} label={label} value={value} />
            ))}
        </SidebarCard>
    );
};
